export const SET_FILTRO_LISTAGEM_PERFIL =
    'SET_FILTRO_LISTAGEM_PERFIL';

export const setFiltroListagem = (filtroListagem) => ({
    type: SET_FILTRO_LISTAGEM_PERFIL,
    filtroListagem,
});
